<template>
  <div>
      <button class="add-user-button" @click="showModalAddUser">ADD NEW USER</button>
      <modal-user v-if="showUserModal" :modal.sync="showUserModal"></modal-user>
      <md-table>
        <md-table-row>
          <!-- <md-table-head>USER ID</md-table-head> -->
          <md-table-head>USER EMAIL</md-table-head>
          <md-table-head>AUTHOR</md-table-head>
          <md-table-head>PERMISSION</md-table-head>
          <md-table-head></md-table-head>
          <md-table-head></md-table-head>
        </md-table-row>

        <md-table-row v-for="(item, key) in userData" :key="key">
          <!-- <md-table-cell>{{ item.uid }}</md-table-cell> -->
          <md-table-cell>{{ item.email }}</md-table-cell>
          <md-table-cell>{{ item.defaultAuthor }}</md-table-cell>
          <md-table-cell>{{ item.permission }}</md-table-cell>
          <md-table-cell><modal-edituser :passedItem="item">EDIT USER</modal-edituser></md-table-cell>
          <md-table-cell><modal-deluser :passedItem="item">REMOVE USER</modal-deluser></md-table-cell>
        </md-table-row>
      </md-table>
  </div>
</template>

<script>
//import request from "axios";
import Vue from "vue";
import firebase from "firebase";
import VueFirestore from "vue-firestore";
require("firebase/firestore");
Vue.use(VueFirestore);
var firestore;
import ModalUser from "../ModalUser.vue";
import ModalDeluser from "../ModalDeluser.vue";
import ModalEdituser from "../ModalEdituser.vue";
export default {
  components: {ModalUser, ModalDeluser, ModalEdituser},
  data: function() {
    firestore = firebase.firestore();
    return {
      showUserModal:false
    };
  },
  firestore() {
    return {
      userData: firestore.collection("users")
    };
  },
  methods: {
    showModalAddUser: function() {
      this.showUserModal = true;
    }
  }
};
</script>



// WEBPACK FOOTER //
// users.vue?7668b055